/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Plan_Could_Not_Open_Management_PageInputs */

const en_plan_could_not_open_management_page = /** @type {(inputs: Plan_Could_Not_Open_Management_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We could not open the ${i?.target} subscription page.`)
};

const es_plan_could_not_open_management_page = /** @type {(inputs: Plan_Could_Not_Open_Management_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No pudimos abrir la página de suscripción de ${i?.target}.`)
};

/**
* | output |
* | --- |
* | "We could not open the {target} subscription page." |
*
* @param {Plan_Could_Not_Open_Management_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_could_not_open_management_page = /** @type {((inputs: Plan_Could_Not_Open_Management_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Could_Not_Open_Management_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_could_not_open_management_page(inputs)
	return en_plan_could_not_open_management_page(inputs)
});